module.exports = __webpack_public_path__ + "img/jiaj.1766ee7e.png";